// define jQuery
jQuery(function($){
